import React, {useEffect, useState} from 'react';
import fonts from '../../../fonts/THSarabunNew.ttf';
import fonts_bold from '../../../fonts/THSarabunNew Bold.ttf';
import {Page, Text, View, Document, StyleSheet, Image, PDFDownloadLink} from '@react-pdf/renderer';
import {PDFViewer} from '@react-pdf/renderer';
import {Font} from '@react-pdf/renderer'
import img from '../../../images/logo.png'
import imgant from '../../../images/ant.jpg'
import Axios from 'axios';
import Constants from '../../../config/constants';
import objDefault from '../../../models/opnoteModel'
import moment from "moment";
import {Form} from "semantic-ui-react";
import {staff} from "../../../config/staff";

const eyes = [
    {key: 4, text: 'Open before stimulus (4)', value: 4},
    {key: 3, text: 'After spoken or shouted request (3)', value: 3},
    {key: 2, text: 'After finger tip stimulus (2)', value: 2},
    {key: 1, text: 'No opening at any time, no interfering factor (1)', value: 1},
    {key: 0, text: 'Closed by local factor (NT)', value: 0}
]
const verbal = [
    {key: 5, text: 'Correctly gives name, place and date (5)', value: 5},
    {key: 4, text: 'Not orientated but communication coherently (4)', value: 4},
    {key: 3, text: 'Intelligible single words (3)', value: 3},
    {key: 2, text: 'Only moans / groans (2)', value: 2},
    {key: 1, text: 'No audible response, no interfering factor (1)', value: 1},
    {key: 0, text: 'Factor interferring with communication (NT)', value: '0'}
]
const best = [
    {key: 6, text: 'Obey 2-part request (6)', value: 6},
    {key: 5, text: 'Brings hand above clavicle to stimulus on head neck (5)', value: 5},
    {key: 4, text: 'Bends arm at elbow rapidly but features not predominantly abnormal (4)', value: 4},
    {key: 3, text: 'Bends arm at elbow, features clearly predominantly abnormal (3)', value: 3},
    {key: 2, text: 'Extends arm at elbow (2)', value: 2},
    {key: 1, text: 'No movement in arms / legs, no interfering factor (1)', value: 1},
    {key: 0, text: 'Paralysed or other limiting factor (NT)', value: 0}
]
Font.register({
    family: 'th',
    fonts: [
        {
            src: fonts
        },
        {
            src: fonts_bold,
            fontWeight: 'bold'
        },

    ]
})
const styles = StyleSheet.create({
    table: {
        display: "table",
        width: "auto",
        borderStyle: "solid",
        borderWidth: 1,
        borderRightWidth: 0,
        borderBottomWidth: 0,
        fontFamily: 'th'
    },

    tableRow: {
        margin: "auto",
        flexDirection: "row",
        fontFamily: 'th'

    },
    table1: {
        display: "table",
        width: "auto",
        borderRightWidth: 0,
        borderBottomWidth: 0,
        fontFamily: 'th'
    },

    tableRow1: {

        flexDirection: "row",
        fontFamily: 'th'

    },
    tableCol: {
        width: "25%",
        borderStyle: "solid",
        borderWidth: 1,
        borderLeftWidth: 0,
        borderTopWidth: 0,

        marginTop: 0
    },
    tableCell: {
        margin: 0,
        marginTop: 0,
        paddingLeft: 5,
        fontSize: 16,
        fontWeight: 'bold',
        textAlign: 'center'
    },

    tableCol3: {
        width: "45%",

        borderLeftWidth: 0,
        borderTopWidth: 0,

    },

    tableColImg: {
        width: "20%",
        marginBottom: 2,
        marginTop: 2,
        borderLeftWidth: 0,
        borderTopWidth: 0,

    },
    tableColDetail: {
        width: "40%",
        marginLeft:230,
        borderLeftWidth: 0,
        borderTopWidth: 0,

    },
    tableCol3_sub: {
        width: "100%",

        borderLeftWidth: 0,
        borderTopWidth: 0,

    },
    tableCol3_head: {
        width: "35%",
        borderLeftWidth: 0,
        borderTopWidth: 0,
        marginLeft: 10
    },
    tableCol3_remark: {
        width: "65%",
        borderLeftWidth: 1,
        borderTopWidth: 0,
        textAlign: 'left',
        marginLeft: 2,
        borderStyle: 'dashed',
        borderRadius: 1,
    },
    tableCell3: {
        margin: 0,
        marginTop: 0,
        paddingLeft: 5,
        fontSize: 12,
        fontWeight: 'bold',
        textAlign: 'left'
    },

    tableCell2: {
        margin: 0,
        marginTop: 0,
        paddingLeft: 20,
        fontSize: 13,
    },
    tableCellData: {
        margin: 0,
        marginTop: 2,
        paddingLeft: 5,
        fontSize: 15,
        textAlign: 'center'
    },

    table2: {
        display: "table",
        width: "auto",
        borderStyle: "solid",
        borderWidth: 1,
        borderRightWidth: 0,
        borderBottomWidth: 0,
    },

    tableRow2: {
        margin: "auto",
        flexDirection: "row",

    },
    tableCol2: {
        width: "33.33%",
        borderStyle: "solid",
        borderWidth: 1,
        borderLeftWidth: 0,
        borderTopWidth: 0,
    },

    body: {
        paddingTop: 0,
        paddingBottom: 0,
        paddingHorizontal: 0,
        fontFamily: 'th',

    },
    textHead: {
        marginTop: 5,
        marginLeft: 20,
        marginRight: 20,

        fontSize: 13,
        fontWeight: 600,
        textAlign: 'justify',
        fontFamily: 'th',
        fontweight: 'bold'
    },
    textContrainer: {
        marginTop: 0,
        marginLeft: 18,
        marginRight: 20,
        fontSize: 12,
        fontWeight: 600,
        textAlign: 'justify',
        fontFamily: 'th'
    },
    textSubContrainer: {
        marginTop: 0,
        marginLeft: 20,
        marginRight: 8,
        fontSize: 13,
        fontWeight: 600,
        textAlign: 'justify',
        fontFamily: 'th'
    },
    textSubContrainer2: {
        marginTop: 10,
        marginBottom: 10,
        marginLeft: 240,
        fontSize: 15,
        fontWeight: 800,
        textAlign: 'justify',
        fontFamily: 'th'
    },
    textSubSecondary: {
        marginTop: 0,
        marginLeft: 60,
        marginRight: 20,
        fontSize: 13,
        fontWeight: 600,
        textAlign: 'justify',
        fontFamily: 'th'
    },

});


// Create Document Component
const Pdf = () => {

    const [input, setInput] = useState({
        ...objDefault
    });
    const [inputList, setInputList] = useState([]);


    useEffect(() => {
        const search = window.location.search;
        const params = new URLSearchParams(search);
        const id = params.get('id')


        setTimeout(
            () => getOpnotById(id),
            2000
        );
        setTimeout(
            () => getAssist(id),
            1200
        );


    }, []);


    const getAssist = async (id) => {
        let response = await Axios.get('http://' + Constants.url + ':' + Constants.port + '/v1/snr/opnoteAssistById?id=' + id,
            {
                headers: {
                    Authorization: Constants.headerAuthorization,
                    'Content-Type': 'application/json'
                }
            });
        response = response.data.data
        setInputList(response)

    }
    const getOpnotById = async (id) => {
        try {

            let response = await Axios.get('http://' + Constants.url + ':' + Constants.port + '/v1/snr/opnoteById?id=' + id,
                {
                    headers: {
                        Authorization: Constants.headerAuthorization,
                        'Content-Type': 'application/json'
                    }
                });

            response = response.data.data[0]
            console.log(response)
            setInput((prevInput) => ({
                ...prevInput,
                id: response.id,
                patient_id: response.patient_id,
                admission_id: response.admission_id,
                age: response.age,
                date: moment(response.date).format("DD-MM-YYYY"),
                department: response.department,
                intern: response.intern,
                diagnosis: response.diagnosis,
                op_date_operation: moment(response.op_date_operation).format("DD-MM-YYYY"),
                op_time_start: response.op_time_start,
                op_time_end: response.op_time_end,
                surgeon: response.surgeon,
                first_assistant: response.first_assistant,
                second_assistant: response.second_assistant,
                scrub_nurse: response.scrub_nurse,
                clinical_diagosis: response.clinical_diagosis,
                post_operative_diagnosis: response.post_operative_diagnosis,
                operative_procedure: response.operative_procedure,
                anesthesia: response.anesthesia,
                anesthetist: response.anesthetist,
                surgical_w_classification: response.surgical_w_classification,
                position: response.position,
                incision: response.incision,
                findings_1: response.findings_1,
                findings_2: response.findings_2,
                findings_3: response.findings_3,
                findings_4: response.findings_4,
                findings_5: response.findings_5,
                img_findings_1: response.img_findings_1,
                img_findings_2: response.img_findings_2,
                img_findings_3: response.img_findings_3,
                img_findings_4: response.img_findings_4,
                img_findings_5: response.img_findings_5,
                procedure: response.procedure,
                estimate_blood: response.estimate_blood,
                complication: response.complication,
                user_record: response.user_record,
                ward: response.ward,
                resident_name: response.resident_name,
                staff: response.staff_id,
                name:response.name,
                surname:response.surname,
                staff_name: response.staff_id ? staff.find(item => item.key === response.staff_id).text : '',
                division: response.division,
                record_name: response.record_name,
                recode_code: response.recode_code,
                hn:response.hn,
                an:response.an,
                gender: response.gender == 'M' ? 'ชาย' : 'หญิง',

            }))

        } catch (e) {

        }
    }


    return (

        <PDFViewer style={{width: '100%', height: '100vh',}}>


            <Document>
                <Page style={styles.body}>
                    <View style={styles.table}>
                        <View style={styles.tableRow}>
                            <View style={styles.tableCol}>

                                <Image style={{width: '55', marginLeft: '45', marginTop: '5'}}

                                       src={img}
                                />

                            </View>
                            <View style={styles.tableCol}>
                                <Text style={styles.tableCell}>Operative note{"\n"}</Text>
                                <Text style={styles.tableCellData}> Deparment of Surgery{"\n"}</Text>
                                <Text style={{fontSize: '10', textAlign: 'center'}}>Faculty of Medicine , Khon Kaen
                                    University</Text>
                            </View>
                            <View style={styles.tableCol}>
                                <Text style={{
                                    fontSize: 12,
                                    fontWeight: 'bold'
                                }}>&nbsp;&nbsp;ผู้บาดเจ็บ {input.name} {input.surname}{"\n"}</Text>
                                <Text style={{
                                    fontSize: 12,
                                    fontWeight: 'bold'
                                }}>&nbsp;&nbsp;HN {input.hn}&nbsp;&nbsp;&nbsp;&nbsp;AN{input.an}{"\n"}</Text>
                                <Text style={{
                                    fontSize: 12,
                                    fontWeight: 'bold'
                                }}>&nbsp;&nbsp;เพศ {input.gender} &nbsp;&nbsp;&nbsp;&nbsp;อายุ
                                    : {input.age}{"\n"}</Text>
                                <Text style={{fontSize: 12, fontWeight: 'bold'}}>&nbsp;&nbsp;Admission Date
                                    :&nbsp;{moment(input.admission_date).format("DD-MM-YYYY")}</Text>
                            </View>
                            <View style={styles.tableCol}>
                                <Text style={{fontSize: 12, fontWeight: 'bold', marginLeft: 5}}>
                                    Ward : {input.ward}{"\n"}
                                    Staff : {input.staff_name}{"\n"}
                                    Resident : {input.resident_name}{"\n"}
                                    Division : {input.division}
                                </Text>
                            </View>
                        </View>
                    </View>
                    <Text style={styles.textHead}>

                        Date of operation : <Text style={{
                        fontSize: 12,
                        fontWeight: 'normal'
                    }}>{input.op_date_operation}</Text>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                        Time started : <Text style={{
                        fontSize: 12,
                        fontWeight: 'normal'
                    }}>{input.op_time_start}</Text>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                        Time ended : <Text style={{fontSize: 12, fontWeight: 'normal'}}>{input.op_time_end}</Text>
                    </Text>
                    <View
                        style={{
                            borderBottomColor: 'black',
                            borderBottomWidth: 1,
                            borderStyle: 'dotted',
                            borderRadius: 1,
                        }}
                    />
                    <View style={styles.tableRow1}>
                        <View style={styles.tableCol3}>
                            <Text style={styles.textSubContrainer}>
                                Surgeon : <Text style={{fontSize: 12, fontWeight: 'normal'}}>{input.surgeon}</Text>
                            </Text>
                        </View>
                    </View>
                    {

                        inputList.map((x, i) => {
                            let a  = i+2
                            return (
                                <View style={styles.tableRow1}>
                                    <View style={styles.tableCol3}>
                                        <Text style={styles.textSubContrainer}>
                                            #{a} Assistant : <Text
                                            style={{fontSize: 12, fontWeight: 'normal'}}>{x.assistant_name}</Text>
                                        </Text>
                                    </View>
                                </View>

                            );
                        })
                    }

                    <View
                        style={{
                            borderBottomColor: 'black',
                            borderBottomWidth: 1,
                            borderStyle: 'dotted',
                            borderRadius: 1,
                        }}
                    />
                    <View style={styles.tableRow1}>
                        <View style={styles.tableCol3}>
                            <Text style={styles.textSubContrainer}>
                                First assistant : <Text
                                style={{fontSize: 12, fontWeight: 'normal'}}>{input.first_assistant}</Text>
                            </Text>
                        </View>

                        <View style={styles.tableCol3}>
                            <Text style={styles.textSubContrainer}>
                                Scrub nurse : <Text
                                style={{fontSize: 12, fontWeight: 'normal'}}>{input.scrub_nurse}</Text>
                            </Text>
                        </View>

                    </View>

                    <View
                        style={{
                            borderBottomColor: 'black',
                            borderBottomWidth: 1,
                            borderStyle: 'dotted',
                            borderRadius: 1,
                        }}
                    />
                    <Text style={styles.textHead}>
                        Clinical diagnosis : <Text
                        style={{fontSize: 12, fontWeight: 'normal'}}>{input.clinical_diagosis}</Text>
                    </Text>
                    <View
                        style={{
                            borderBottomColor: 'black',
                            borderBottomWidth: 1,
                            borderStyle: 'dotted',
                            borderRadius: 1,
                        }}
                    />
                    <Text style={styles.textHead}>

                        Post-operative diagnosis : <Text
                        style={{fontSize: 12, fontWeight: 'normal'}}>{input.post_operative_diagnosis}</Text>
                    </Text>
                    <View
                        style={{
                            borderBottomColor: 'black',
                            borderBottomWidth: 1,
                            borderStyle: 'dotted',
                            borderRadius: 1,
                        }}
                    />
                    <Text style={styles.textHead}>

                        Operative procedure : <Text
                        style={{fontSize: 12, fontWeight: 'normal'}}>{input.operative_procedure}</Text>
                    </Text>
                    <View
                        style={{
                            borderBottomColor: 'black',
                            borderBottomWidth: 1,
                            borderStyle: 'dotted',
                            borderRadius: 1,
                        }}
                    />
                    <View style={styles.tableRow1}>
                        <View style={styles.tableCol3}>
                            <Text style={styles.textSubContrainer}>
                                Anesthesia : <Text
                                style={{fontSize: 12, fontWeight: 'normal'}}>{input.anesthesia}</Text>
                            </Text>
                        </View>
                        <View style={styles.tableCol3}>
                            <Text style={styles.textSubContrainer}>
                                Anesthesiologist : <Text
                                style={{fontSize: 12, fontWeight: 'normal'}}>{input.anesthetist}</Text>
                            </Text>
                        </View>
                    </View>

                    <View
                        style={{
                            borderBottomColor: 'black',
                            borderBottomWidth: 1,
                            borderStyle: 'dotted',
                            borderRadius: 1,
                        }}
                    />

                    <Text style={styles.textHead}>
                        Surgical Wound Classicfication : <Text
                        style={{fontSize: 12, fontWeight: 'normal'}}>{input.surgical_w_classification}</Text>
                    </Text>
                    <Text style={styles.textSubContrainer2}>

                        DESCRIPTION OF OPERATION
                    </Text>
                    <Text style={styles.textSubContrainer}>
                        Position : <Text style={{fontSize: 12, fontWeight: 'normal'}}>{input.position}</Text>
                    </Text>
                    <View
                        style={{
                            borderBottomColor: 'black',
                            borderBottomWidth: 1,
                            borderStyle: 'dotted',
                            borderRadius: 1,
                        }}
                    />
                    <Text style={styles.textHead}>
                        Incision : <Text style={{fontSize: 12, fontWeight: 'normal'}}>{input.incision}</Text>
                    </Text>
                    <View
                        style={{
                            borderBottomColor: 'black',
                            borderBottomWidth: 1,
                            borderStyle: 'dotted',
                            borderRadius: 1,
                        }}
                    />
                    <Text style={styles.textSubContrainer}>
                        Finding
                    </Text>
                    {
                        input.img_findings_1 ?
                            <>
                                <View style={styles.tableRow1}>
                                    <View style={styles.tableColImg}>
                                        <Image style={{
                                            width: '300',
                                            height: '300',
                                            marginLeft: '40',
                                            marginTop: '0',
                                            border: '1'
                                        }}

                                               src={'http://' + Constants.url + ':' + Constants.port + '/v1/snr/static?pic=' + input.img_findings_1}
                                        />
                                    </View>
                                    <View style={styles.tableColDetail}>
                                        <Text style={styles.textSubContrainer}>
                                            detail : <Text
                                            style={{fontSize: 12, fontWeight: 'normal'}}>{input.findings_1}</Text>
                                        </Text>
                                    </View>
                                </View>
                                <View
                                    style={{
                                        borderBottomColor: 'black',
                                        borderBottomWidth: 1,
                                        borderStyle: 'dotted',
                                        borderRadius: 1,
                                    }}
                                />

                            </> : <View></View>

                    }
                    {
                        input.img_findings_2 ?
                            <>
                                <View style={styles.tableRow1}>
                                    <View style={styles.tableColImg}>
                                        <Image style={{
                                            width: '300',
                                            height: '300',
                                            marginLeft: '40',
                                            marginTop: '0',
                                            border: '1'
                                        }}

                                               src={'http://' + Constants.url + ':' + Constants.port + '/v1/snr/static?pic=' + input.img_findings_2}
                                        />
                                    </View>
                                    <View style={styles.tableColDetail}>
                                        <Text style={styles.textSubContrainer}>
                                            detail : <Text
                                            style={{fontSize: 12, fontWeight: 'normal'}}>{input.findings_2}</Text>
                                        </Text>
                                    </View>
                                </View>
                                <View
                                    style={{
                                        borderBottomColor: 'black',
                                        borderBottomWidth: 1,
                                        borderStyle: 'dotted',
                                        borderRadius: 1,
                                    }}
                                />
                            </> : <View></View>

                    }
                    {
                        input.img_findings_3 ?
                            <>
                                <View style={styles.tableRow1}>
                                    <View style={styles.tableColImg}>
                                        <Image style={{
                                            width: '300',
                                            height: '300',
                                            marginLeft: '40',
                                            marginTop: '0',
                                            border: '1'
                                        }}

                                               src={'http://' + Constants.url + ':' + Constants.port + '/v1/snr/static?pic=' + input.img_findings_3}
                                        />
                                    </View>
                                    <View style={styles.tableColDetail}>
                                        <Text style={styles.textSubContrainer}>
                                            detail : <Text
                                            style={{fontSize: 12, fontWeight: 'normal'}}>{input.findings_3}</Text>
                                        </Text>
                                    </View>
                                </View>
                                <View
                                    style={{
                                        borderBottomColor: 'black',
                                        borderBottomWidth: 1,
                                        borderStyle: 'dotted',
                                        borderRadius: 1,
                                    }}
                                />
                            </> : <View></View>

                    }
                    {
                        input.img_findings_4 ?
                            <>
                                <View style={styles.tableRow1}>
                                    <View style={styles.tableColImg}>
                                        <Image style={{
                                            width: '300',
                                            height: '300',
                                            marginLeft: '40',
                                            marginTop: '0',
                                            border: '1'
                                        }}

                                               src={'http://' + Constants.url + ':' + Constants.port + '/v1/snr/static?pic=' + input.img_findings_4}
                                        />
                                    </View>
                                    <View style={styles.tableColDetail}>
                                        <Text style={styles.textSubContrainer}>
                                            detail : <Text
                                            style={{fontSize: 12, fontWeight: 'normal'}}>{input.findings_4}</Text>
                                        </Text>
                                    </View>
                                </View>
                                <View
                                    style={{
                                        borderBottomColor: 'black',
                                        borderBottomWidth: 1,
                                        borderStyle: 'dotted',
                                        borderRadius: 1,
                                    }}
                                />
                            </> : <View></View>
                    }
                    {
                        input.img_findings_5 ?
                            <>
                                <View style={styles.tableRow1}>
                                    <View style={styles.tableColImg}>
                                        <Image style={{
                                            width: '300',
                                            height: '300',
                                            marginLeft: '40',
                                            marginTop: '0',
                                            border: '1'
                                        }}
                                               src={'http://' + Constants.url + ':' + Constants.port + '/v1/snr/static?pic=' + input.img_findings_5}
                                        />
                                    </View>
                                    <View style={styles.tableColDetail}>
                                        <Text style={styles.textSubContrainer}>
                                            detail : <Text
                                            style={{fontSize: 12, fontWeight: 'normal'}}>{input.findings_5}</Text>
                                        </Text>
                                    </View>
                                </View>
                                <View
                                    style={{
                                        borderBottomColor: 'black',
                                        borderBottomWidth: 1,
                                        borderStyle: 'dotted',
                                        borderRadius: 1,
                                    }}
                                />
                            </> : <View></View>
                    }
                    <Text style={styles.textHead}>
                        Procedures : <Text style={{fontSize: 12, fontWeight: 'normal'}}>{input.procedure}</Text>

                    </Text>
                    <View style={styles.tableRow1}>
                        <View style={styles.tableCol3}>
                            <Text style={styles.textSubContrainer}>
                                Estimate blood loss : <Text
                                style={{fontSize: 12, fontWeight: 'normal'}}>{input.estimate_blood} ml.</Text>
                            </Text>
                        </View>
                        <View style={styles.tableCol3}>
                            <Text style={styles.textSubContrainer}>
                                Complications : <Text
                                style={{fontSize: 12, fontWeight: 'normal'}}>{input.complication}</Text>
                            </Text>
                        </View>
                    </View>
                    <View
                        style={{
                            borderBottomColor: 'black',
                            borderBottomWidth: 1,
                            borderStyle: 'dotted',
                            borderRadius: 1,
                            marginBottom: 5
                        }}
                    />
                    <View style={styles.table2}>
                        <View style={styles.tableRow2}>
                            <View style={styles.tableCol2}>
                                <Text style={styles.tableCell2}>
                                    {"\n"}
                                    <Text style={{
                                        fontSize: 12,
                                        fontWeight: 'bold'
                                    }}>&nbsp;&nbsp;Department : {input.department}</Text>
                                </Text>
                            </View>
                            <View style={styles.tableCol2}>
                                <Text style={styles.tableCell2}>
                                    {"\n"}
                                    <Text style={{
                                        fontSize: 12,
                                        fontWeight: 'bold'
                                    }}>&nbsp;&nbsp;Staff : {input.staff_name}</Text>

                                </Text>
                            </View>
                            <View style={styles.tableCol2}>
                                <Text style={styles.tableCell2}>
                                    {"\n"}
                                    <Text style={{fontSize: 12, fontWeight: 'bold'}}> Sign :
                                        .....................................................................</Text>
                                </Text>
                            </View>

                        </View>
                    </View>
                </Page>
            </Document>
        </PDFViewer>
    );
}
export default Pdf;
